
class State {
    constructor(versionState) {
        this.version = versionState[0];
        this.setVersion = versionState[1];
    }

    add(name, initValue) {
        if (!this.hasOwnProperty(name)) {
            this[name] = initValue;
            this['set' + name.charAt(0).toUpperCase() + name.slice(1)] = (value, force = false) => {
                this.set(name, value, force)
            }
        }
    }

    get(name) {
        return this[name];
    }

    set(name, val, force = false) {
        if (this.hasOwnProperty(name) && (this[name] !== val || force)) {
            this[name] = val;
            this.update();
        }
    }

    update() {
        this.version++;
        this.setVersion(this.version);
    }
}
export default State;